// named export (recommended)
export const COMMERCIAL_BROKER = {
    // section: ["overviewSection", "roiInvestorBenefits", "investmentOpportunity", "commercialOperationalBenefits", "communicationChannel"],
    href: "/investments/commercial-broker",
    overviewSection: {
        sectionId: "rentalInvestment",
        title: "Overview",
        subtitle:
            "RSL Commercial Brokers is a Dubai-based platform that connects entrepreneurs, investors, and business owners to buy and sell businesses across industries.",
        cards: [
            {
                title: "Business Listings",
                body: "Sellers showcase their businesses on the platform.",
                arrow: "/img/app/Right-top-arrow.svg",
            },
            {
                title: "Buyer Access",
                body: "Investors explore vetted opportunities matching their needs.",
                arrow: "/img/app/Right-bottom-arrow.svg",
            },
            {
                title: "Deal Support",
                body: "RSL manages negotiations, due diligence, and compliance.",
                arrow: "/img/app/Right-top-arrow.svg",
            },
            {
                title: "Brokerage Fee",
                body: "20% charged on successful deal closure.",
            },
        ],
        button: { text: "Invest Now", link: "#" },
    },
    roiInvestorBenefits: {
        sectionId: "overview",
        title: "ROI & Investor Benefits",
        subtitle:
            "Choose which suits you better",
        image: {
            src: "/img/investments/commercial/banner.svg",
            alt: " Hands offering coins"
        },
        button: { text: "Invest Now", link: "#" },
        bgcolor: "#f9f9f9",
    },
    investmentOpportunity: {
        sectionId: "opportunityForInvestment",
        title: "Operating Model",
        subtitle:
            "Make journey comfortable with",
        cardData: [
            {
                title: "Business Onboarding & Vetting",
                description: [
                    "Seller submits a request to list their business.",
                    "RSL conducts verification according to the Business Vetting & Verification Checklist.",
                    "Approved businesses go live on Marketplace.",
                ],
                icon: "/img/investments/limousine/card1.svg",
                vector: "/img/investments/commercial/vector1.svg", // BR (bottom-right)
                arcSide: "right",
                arcAnchor: "bottom",
            },
            {
                title: "Marketplace Listing",
                description: [
                    "Businesses are presented with detailed profiles, financials highlights, key investment Sponsored marketing campaigns amplify visibility to attract serious buyers.",
                ],
                icon: "/img/investments/limousine/card2.svg",
                vector: "/img/investments/commercial/vector2.svg", // BL (bottom-left)
                arcSide: "left",
                arcAnchor: "bottom",
            },
            {
                title: "Deal Closure",
                description: [
                    "Brokerage fee will be 20% of total transaction value",
                    "AED 5,000 charged upon onboarding/listing, non-refundable, covering marketing, operations, and administrative costs.",
                ],
                icon: "/img/investments/limousine/card3.svg",
                vector: "/img/investments/commercial/vector3.svg", // TL (top-left)
                arcSide: "right",
                arcAnchor: "top",
            },
            {
                title: "Buyer Engagement",
                description: [
                    "Interested buyers/investors request access to additional details under NDA.",
                    "RSL facilitates meetings and negotiations."
                ],
                icon: "/img/investments/limousine/card4.svg",
                vector: "/img/investments/commercial/vector4.svg", // TR (top-right)
                arcSide: "left",
                arcAnchor: "top",
            },
        ]
    },
    commercialOperationalBenefits: {
        subtitle: "Choose which suits you better",
        title: "Operational Benefits",
        accentColor: "#0F7F8A",
        sellers: {
            title: "For Sellers",
            icons: "/img/investments/commercial/oval1.svg",
            items: [
                "Access to a professional, global investor pool",
                "Confidential listing process with NDA protections",
                "Marketing campaigns targeting relevant buyers",
                "End-to-end transaction support",
            ],
        },
        buyers: {
            title: "For Buyers/Investors",
            icons: "/img/investments/commercial/oval2.svg",
            items: [
                "Access to vetted businesses with verified documentation",
                "Transparent deal information, reducing risk",
                "Streamlined acquisition process with RSL facilitation",
                "Support in diligence & contract structuring",
            ],
        },
        strategic: {
            title: "Strategic Value to RSL",
            icons: "/img/investments/commercial/oval3.svg",
            items: [
                "Trusted commercial brokerage in Dubai",
                "Diversifies revenue through transaction-based brokerage fees",
                "Strengthens RSL’s network across industries",
                "Builds long-term relationships with entrepreneurs, investors, and SMEs",
            ],
        },
        images: {
            rightTop: { src: "/img/investments/commercial/for-sale.svg", alt: "For sale" },
            leftMiddle: { src: "/img/investments/commercial/agent-tour.svg", alt: "Agent showing property" },
            rightBottom: { src: "/img/investments/commercial/team-fistbump.svg", alt: "Team support" },
        },
        button: { text: "Invest Now", link: "#" },
    },
    communicationChannel: {
        sectionId: "communicationChannel",
        title: "Communication Channel",
        subtitle:
            "Choose which suits you better",
        bottomHeader: "RSL ensures smooth communication and transparency for all investors and drivers:",
        cardData: [
            {
                heading: "Call Center (UAE):",
                iconSrc: "/img/investments/phone.svg",
                iconAlt: "Phone",
                url: [
                    {
                        href: "tel:+97143977746",
                        label: "+971 4 397 7746"
                    }
                ]
            },
            {
                heading: "Email (Investors):",
                iconSrc: "/img/investments/email.svg",
                iconAlt: "Email",
                url: [
                    {
                        href: "mailto:investors@royalsmartlifestyle.com",
                        label: "investors@royalsmartlifestyle.com"
                    }
                ]
            },
            {
                heading: "Websites",
                iconSrc: "/img/investments/globe.svg",
                iconAlt: "Globe",
                url: [{
                    href: "https://www.royalsmartlimousine.com",
                    label: "https://www.royalsmartlimousine.com"
                }
            ]
            }
        ],
        image: {
            src: "/images/bannerImage/rsl_super_app.svg",
            alt: "RSL SUPER APP"
        }
    }
};

export const COMMERCIAL_BROKER_page = {
    carToInvest: {
        sectionId: "overview",
        title: "Pick Your Car To Invest",
        subtitle:
            "Make journey comfortable with",
        image: {
            src: "/img/investments/commercial/car-to-invest.svg",
            alt: " Hands offering coins"
        },
        button: { text: "Invest Now", link: "#" },
        bgcolor: "#fff",
    },
    approvesBusiness: {
        sectionId: "overview",
        title: "How RSL Approves Business",
        subtitle:
            "Make journey comfortable with",
        image: {
            src: "/img/investments/commercial/approve-business.svg",
            alt: " Hands offering coins"
        },
        button: { text: "Invest Now", link: "#" },
        bgcolor: "#f9f9f9",
    },
    onboardingProcess: {
        sectionId: "overview",
        title: "Investor/Seller Onboarding Process",
        subtitle:
            "Make journey comfortable with",
        image: {
            src: "/img/investments/commercial/onboarding-process.svg",
            alt: " Hands offering coins"
        },
        bgcolor: "#fff",
    },
    communicationChannel: {
        sectionId: "communicationChannel",
        image: {
            src: "/images/bannerImage/rsl_super_app.svg",
            alt: "RSL SUPER APP"
        }
    }
}